import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { Package } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function UserDashboard() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/orders`, {
        withCredentials: true
      });
      setOrders(data);
    } catch (error) {
      console.error('Error fetching orders:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl sm:text-5xl font-light text-[#374963] mb-8" data-testid="dashboard-title">
          Mi Cuenta
        </h1>

        {/* User Info */}
        <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-8 mb-8">
          <h2 className="text-2xl font-semibold text-[#374963] mb-4">Información Personal</h2>
          <div className="space-y-2">
            <p className="text-[#73706e]"><strong>Nombre:</strong> {user?.name}</p>
            <p className="text-[#73706e]"><strong>Email:</strong> {user?.email}</p>
          </div>
        </div>

        {/* Orders */}
        <div className="bg-white rounded-xl shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-8">
          <h2 className="text-2xl font-semibold text-[#374963] mb-6">Mis Pedidos</h2>
          {loading ? (
            <p className="text-[#73706e]">Cargando pedidos...</p>
          ) : orders.length === 0 ? (
            <div className="text-center py-8" data-testid="no-orders-message">
              <Package className="w-16 h-16 text-[#73706e] mx-auto mb-4" />
              <p className="text-[#73706e]">Aún no has realizado ningún pedido</p>
            </div>
          ) : (
            <div className="space-y-4">
              {orders.map((order) => (
                <div key={order.order_id} className="border border-[rgba(55,73,99,0.1)] rounded-lg p-6" data-testid={`order-${order.order_id}`}>
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <p className="text-sm text-[#73706e]">Pedido #{order.order_id}</p>
                      <p className="text-sm text-[#73706e]">{new Date(order.created_at).toLocaleDateString('es-ES')}</p>
                    </div>
                    <span className="px-3 py-1 bg-[#374963] text-white rounded-full text-sm">
                      {order.status}
                    </span>
                  </div>
                  <div className="border-t border-[rgba(55,73,99,0.1)] pt-4">
                    <p className="text-[#374963] font-semibold">Total: {order.total.toFixed(2)}€</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UserDashboard;